import React from 'react';
import cls from './Modal.module.css';
import classNames from 'classnames';

const Modal = ({
    isOpen = false,
    onHideModal,
    children,
    zIndex = null,
    classes,
    needClose = true,
    contentClasses,
}) => {
    return (
        <>
            {isOpen && (
                <div className={classNames(cls.customModal, { [cls.zIndex]: zIndex })}>
                    <div className={classNames(cls.customModalOverlay, [classes])}>
                        <div className={classNames(cls.customModalContent, [contentClasses])}>
                            {needClose && (
                                <div
                                    className={classNames(cls.customModalClose)}
                                    onClick={onHideModal}
                                >
                                    <svg
                                        width="28"
                                        height="28"
                                        viewBox="0 0 28 28"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6.40647 6.40615C6.67995 6.13275 7.05082 5.97917 7.43751 5.97917C7.82421 5.97917 8.19508 6.13275 8.46856 6.40615L14 11.9376L19.5315 6.40615C19.666 6.26686 19.8269 6.15576 20.0048 6.07934C20.1828 6.00291 20.3741 5.96268 20.5678 5.96099C20.7614 5.95931 20.9534 5.99621 21.1327 6.06953C21.3119 6.14286 21.4747 6.25115 21.6116 6.38807C21.7486 6.525 21.8568 6.68783 21.9302 6.86705C22.0035 7.04627 22.0404 7.23831 22.0387 7.43194C22.037 7.62558 21.9968 7.81694 21.9204 7.99486C21.8439 8.17279 21.7328 8.33371 21.5936 8.46823L16.0621 13.9997L21.5936 19.5311C21.8592 19.8062 22.0062 20.1746 22.0029 20.5569C21.9995 20.9393 21.8462 21.3051 21.5758 21.5755C21.3054 21.8459 20.9396 21.9992 20.5573 22.0026C20.1749 22.0059 19.8065 21.8589 19.5315 21.5932L14 16.0618L8.46856 21.5932C8.19351 21.8589 7.82513 22.0059 7.44276 22.0026C7.06039 21.9992 6.69462 21.8459 6.42424 21.5755C6.15385 21.3051 6.00048 20.9393 5.99716 20.5569C5.99383 20.1746 6.14083 19.8062 6.40647 19.5311L11.9379 13.9997L6.40647 8.46823C6.13308 8.19475 5.97949 7.82389 5.97949 7.43719C5.97949 7.05049 6.13308 6.67963 6.40647 6.40615Z"
                                            fill="#F5F5F5"
                                        />
                                    </svg>
                                </div>
                            )}
                            {children}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Modal;
